import { render } from "./ProposalOpinionSection.vue?vue&type=template&id=207d33fb&scoped=true"
import script from "./ProposalOpinionSection.vue?vue&type=script&lang=js"
export * from "./ProposalOpinionSection.vue?vue&type=script&lang=js"

import "./ProposalOpinionSection.vue?vue&type=style&index=0&id=207d33fb&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-207d33fb"]])

export default __exports__